module.exports = __webpack_public_path__ + "img/connected.d6aea39f.svg";